import { Button, Modal, ModalBody } from "flowbite-react";
import { TermsContent } from "./ModalTerms";

export function ModalContract({ isOpen, onClose }) {
  return (
    <Modal show={isOpen} onClose={onClose} size="5xl">
      <ModalBody>
        <TermsContent />
      </ModalBody>
      <Modal.Footer className="flex justify-center pt-2 pb-3">
        <Button onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
